
export type PricingTier = {
  id: string;
  tierId: "solo" | "small" | "medium";
  name: string;
  seats: string;
  price: string;
  perSeat: string;
  highlight?: boolean;
  paymentLink: string;      // Stripe Payment Link URL (live‑mode)
  stripePriceId?: string;   // populated when you migrate to Price‑ID checkout
};

export const TIERS: PricingTier[] = [
  {
    id: "solo",
    tierId: "solo",
    name: "Solo Director",
    seats: "1 seat",
    price: "$1,799",
    perSeat: "$1,799 per seat",
    paymentLink: "https://buy.stripe.com/28E14ofk4h2n7eie3UaMU04"
  },
  {
    id: "small",
    tierId: "small",
    name: "Small Board",
    seats: "Up to 5 seats",
    price: "$6,495",
    perSeat: "$1,299 per seat",
    highlight: true,
    paymentLink: "https://buy.stripe.com/9B64gAdbWfYj4269NEaMU05"
  },
  {
    id: "medium",
    tierId: "medium",
    name: "Medium Board",
    seats: "6 – 10 seats",
    price: "$11,990",
    perSeat: "$1,199 per seat",
    paymentLink: "https://buy.stripe.com/3cI9AU1te7rN9mqcZQaMU06"
  }
];
